import React from 'react';

/**
 * Subtle pill when multiple host tabs/devices are on the same session (same-browser BroadcastChannel).
 * @param {number} count - Total host connections including this tab (show when count > 1)
 */
const HostsActiveIndicator = ({ count, className = '' }) => {
  if (!count || count <= 1) return null;

  const label = `${count} host${count > 1 ? 's' : ''} active`;

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border border-border-medium bg-surface-subtle px-2.5 py-1 text-xs font-medium text-text-secondary ${className}`.trim()}
      title={label}
      aria-label={label}
    >
      <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-success animate-pulse" aria-hidden />
      {label}
    </span>
  );
};

export default HostsActiveIndicator;
